// extracted by mini-css-extract-plugin
module.exports = {"large":"only screen and (min-width: 992px)","color-keyline-grey":"#C2C2C2","colorKeylineGrey":"#C2C2C2","wrapper":"_1YOGK","grid":"_16Bcv","item":"_2AW6e","fullWidth":"_28M20"};